/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/display-name */
// TODO: Fix display name
// TODO: Fix accessibility

import { forwardRef, useCallback, useMemo } from 'react';
import './waterfall-tooltip.component.scss';
import { IMAGES_REPO } from '../../../../../static-resources';
import { WaterfallData } from '../hooks/waterfall-data.interface';
import { WaterfallTooltipBodySingleComponent } from './waterfall-tooltip-body-single.component';
import { WaterfallTooltipBodyComponent } from './waterfall-tooltip-body.component';

export interface WaterfallTooltipComponentProps {
  data: WaterfallData | undefined;
  dataIndex?: number | undefined;
  onMouseOver?(dataIndex: number | undefined): void;
}
export const WaterfallTooltipComponent = forwardRef(
  (
    { data, dataIndex, onMouseOver }: WaterfallTooltipComponentProps,
    ref: any,
  ) => {
    const onClose = useCallback(() => {
      if (ref) {
        const tooltipEl = ref.current;
        if (tooltipEl) {
          tooltipEl.style.opacity = '0';
          tooltipEl.style.pointerEvents = 'none';
        }
      }
    }, [ref]);

    const singleChart = useMemo(() => {
      if (!data) {
        return false;
      }
      if (data.children && data.children?.length <= 1) {
        return true;
      } else {
        return false;
      }
    }, [data]);
    return (
      <div
        ref={ref}
        className="waterfall-tooltip-container"
        onMouseOver={() => (onMouseOver ? onMouseOver(dataIndex) : null)}
      >
        <div className="waterfall-tooltip-title">
          <div className="d-flex">Distribution Details - {data?.label}</div>
          <div className="ms-auto">
            <img
              src={IMAGES_REPO.CloseIcon}
              alt="Close"
              className="waterfall-tooltip-close"
              onClick={() => onClose()}
            />
          </div>
        </div>

        {singleChart && <WaterfallTooltipBodySingleComponent data={data} />}
        {!singleChart && <WaterfallTooltipBodyComponent data={data} />}
      </div>
    );
  },
);
